export default {
  animationEasing: 'quarticInOut',
  title: {
    text: '34534',
    subtext: '营收总额',
    textAlign: 'center',
    textStyle: {
      color: '#E63535',
      fontSize: 14,
    },
    subtextStyle: {
      color: '#262D40',
      fontSize: 11,
    },
    x: '30.5%',
    y: '37%',
  },
  grid: {
    left: '0',
    right: '0',
    top: '0%',
    bottom: '0%',
  },
  series: [
    {
      name: '持股分析',
      type: 'pie',
      center: ['34%', '48%'],
      radius: ['47%', '68%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderWidth: 1.5,
        borderColor: '#fff',
      },
      hoverAnimation: false,
      label: {
        show: false,
        position: 'inside',
        emphasis: {
          show: false,
          textStyle: {
            fontSize: '14'
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      data: []
    }
  ]
}